export default "__VITE_ASSET__BqqQPLTl__"